export default {"src":"/_next/static/media/undraw_digital_nomad.abb40550.svg","height":729,"width":667,"blurWidth":0,"blurHeight":0};